import { GhostButton, GridItem, Text } from "@certn/cascadia-react";
import { components } from "@certn/legacy-api/generated-schemas/people";
import { css } from "@emotion/css";
import { useField } from "formik";
import { useContext, useState } from "react";
import { Trans } from "react-i18next";

import { EmploymentHistoryList } from "./EmploymentHistoryList";
import { EmploymentHistoryModal } from "./EmploymentHistoryModal";
import { ApplicationContext } from "../../Application.context";

export function EmploymentHistoryInputField({
  field: config,
}: {
  field: components["schemas"]["EmploymentCheckField"];
}) {
  const { saveData } = useContext(ApplicationContext);
  const [field, , helpers] = useField(config.name);
  const [employers, setEmployers] = useState<
    components["schemas"]["EmploymentCheckFieldValue"][]
  >(field.value);

  const handleSaveEmployer = (
    newEmployer: components["schemas"]["EmploymentCheckFieldValue"],
    index: number
  ) => {
    const newEmployers = [...employers];
    newEmployers[index] = newEmployer;
    saveEntries(newEmployers);
  };

  const handleDeleteEmployer = (index: number) => {
    const newEmployers = employers?.filter((_, i) => index !== i);
    saveEntries(newEmployers);
  };

  const saveEntries = async (
    entries: components["schemas"]["EmploymentCheckFieldValue"][]
  ) => {
    setEmployers(entries);
    await helpers.setValue(entries); // await required for race condition
    await saveData({ skipValidation: true, hasMultipleEntries: true });
  };

  return (
    <>
      <GridItem>
        <Text style="form/section-heading">
          <Trans>My employment history</Trans>
        </Text>
      </GridItem>

      {employers?.length > 0 && (
        <EmploymentHistoryList
          employers={employers}
          onSave={handleSaveEmployer}
          onDelete={handleDeleteEmployer}
        />
      )}

      <GridItem
        className={css({
          display: "block",
        })}
      >
        <EmploymentHistoryModal
          index={employers?.length}
          onSave={handleSaveEmployer}
          trigger={
            <GhostButton
              testID="employment-history-add-employer-button"
              leftIcon="add"
              size="medium"
              fill="background-base"
              border="border-strong"
            >
              <Trans>Add employer</Trans>
            </GhostButton>
          }
        />
      </GridItem>
    </>
  );
}
